var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueBgCp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.96875,
    width: 44,
    height: 44,
    rx: 22,
    fill: "#D2ECF8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7086_76422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 31.9688H13C12.7348 31.9688 12.4804 31.8634 12.2929 31.6759C12.1054 31.4883 12 31.234 12 30.9688V14.9688C12 14.7035 12.1054 14.4492 12.2929 14.2616C12.4804 14.0741 12.7348 13.9688 13 13.9688H20C20 14.4992 20.2107 15.0079 20.5858 15.383C20.9609 15.758 21.4696 15.9688 22 15.9688C22.5304 15.9688 23.0391 15.758 23.4142 15.383C23.7893 15.0079 24 14.4992 24 13.9688H31C31.2652 13.9688 31.5196 14.0741 31.7071 14.2616C31.8946 14.4492 32 14.7035 32 14.9688V30.9688C32 31.234 31.8946 31.4883 31.7071 31.6759C31.5196 31.8634 31.2652 31.9688 31 31.9688H24C24 31.4383 23.7893 30.9296 23.4142 30.5545C23.0391 30.1795 22.5304 29.9688 22 29.9688C21.4696 29.9688 20.9609 30.1795 20.5858 30.5545C20.2107 30.9296 20 31.4383 20 31.9688ZM18.535 29.9688C18.886 29.3604 19.3911 28.8553 19.9993 28.5042C20.6076 28.1531 21.2977 27.9684 22 27.9688C23.48 27.9688 24.773 28.7727 25.465 29.9688H30V15.9688H25.465C25.114 16.5771 24.6089 17.0822 24.0007 17.4333C23.3924 17.7844 22.7023 17.9691 22 17.9688C21.2977 17.9691 20.6076 17.7844 19.9993 17.4333C19.3911 17.0822 18.886 16.5771 18.535 15.9688H14V29.9688H18.535ZM16 18.9688H18V26.9688H16V18.9688ZM26 18.9688H28V26.9688H26V18.9688Z",
    fill: "#1C9FDA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7086_76422"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(10 10.9688)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBgCp);
export default __webpack_public_path__ + "static/media/blueBgCp.5bbad37c8e31672ba5506a08d21e6f53.svg";
export { ForwardRef as ReactComponent };